import axios from 'axios';

const baseU = () => {
  if(window.location.origin.replace(':3000',':9680') == "http://128.134.246.15"){
      return "http://128.134.246.15/api";
  }
  else if(window.location.hostname === 'localhost'){
      return '';
  }
  else if(window.location.hostname === 'insighthub.kr'){
      return 'https://insighthub.kr/api';
  }
  else{
      return window.location.origin.replace(':3000',':9680');
  }
}

const api = axios.create({
  baseURL: baseU(),
  withCredentials: true,
});

export default api;
